"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotBalancesTableContainer = void 0;
var _reactRedux = require("react-redux");
var _reselect = require("reselect");
var _SpotBalancesTable = require("./SpotBalancesTable");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
var _productPositionSelectors = require("../../../redux/selectors/productPositionSelectors");
var filteredProductsSelector = (0, _reselect.createSelector)(_productPositionSelectors.productPositionAssetsSelector, function (_, _ref) {
  var searchText = _ref.searchText;
  return searchText;
}, function (products, searchText) {
  return products.filter(function (p) {
    // Ensures products without a position are not included in table (for hide small amounts)
    if (!p.AccountId) {
      return false;
    }
    var product = (p === null || p === void 0 ? void 0 : p.ProductSymbol) || '';
    var productFullName = (p === null || p === void 0 ? void 0 : p.ProductFullName) || '';
    return product.toUpperCase().includes(searchText.toUpperCase()) || productFullName.toUpperCase().includes(searchText.toUpperCase());
  });
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    loading: state.position.fetching,
    products: filteredProductsSelector(state, ownProps),
    notionalProduct: (0, _productsSelectors.baseNotionalProductSelector)(state)
  };
};
var SpotBalancesTableContainer = exports.SpotBalancesTableContainer = (0, _reactRedux.connect)(mapStateToProps)(_SpotBalancesTable.SpotBalancesTable);